import React from "react";

const ExpenseCard = ({ title, amount, percent, isPositive }) => {
  return (
    <div className="card border-0 shadow-sm p-3 h-100">
      <div className="d-flex justify-content-between">
        <div
          style={{
            width: 30,
            height: 30,
            borderRadius: "50%",
            background: "#ffe5d0",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#ff7a00",
            fontWeight: "bold",
          }}
        >
          $
        </div>
      </div>

      <h5 className="fw-bold">{amount}</h5>

      <div className="progress my-2" style={{ height: "5px" }}>
        <div
          className="progress-bar bg-primary"
          style={{ width: `${percent}%` }}
        />
      </div>

      <small style={{ color: isPositive ? "green" : "red" }}>
        {isPositive ? "+" : "-"}
        {percent}% from last month
      </small>
    </div>
  );
};

export default ExpenseCard;
